import { useTheme } from "next-themes";
import Span from "../ui/Span";
import Paragraph from "../ui/paragraph";
import Tooltip from "../ui/tooltip";
import Iconify from "../ui/Iconify";
import { useTranslations } from "@/lib/static-intl";

const ThemeSwitcher = ({ themeIcons }) => {
  const t = useTranslations("header");
  const { theme, setTheme } = useTheme();

  const handleThemeChange = (themeLabel) => {
    setTheme(themeLabel === undefined ? "light" : themeLabel);
  };

  return (
    <div className="flex flex-col gap-3 px-2 py-2.5 mb-1">
      <Span
        className={"dark:!text-dark_tertiary_label !text-light_secondary_label"}
      >
        {t("theme")}
      </Span>
      <div className="flex items-center justify-between">
        <Paragraph className={"dark:!text-dark_secondary_label"}>
          {theme === "light"
            ? t("light")
            : theme === "dark"
              ? t("dark")
              : t("system")}
        </Paragraph>
        <div className="flex justify-evenly items-center dark:bg-[#212121] bg-light_bg_grey w-20 h-7 rounded-full">
          {themeIcons?.map((icon, i) => (
            <Tooltip
              key={i}
              tooltip={t(icon?.tooltip)}
              className={"!text-nowrap -top-9"}
            >
              <div
                className={`group flex justify-center items-center w-6 h-6 rounded-full ${theme === icon?.theme
                    ? "dark:bg-dark_bg_grey bg-dark_primary_label"
                    : ""
                  }`}
              >
                <Iconify
                  icon={icon?.icon}
                  className={`!w-3 ${theme === icon?.theme || undefined
                      ? "dark:!text-dark_primary_label !text-light_primary_label"
                      : "dark:!text-dark_tertiary_label group-hover:dark:!text-dark_primary_label !text-light_secondary_label group-hover:!text-light_primary_label"
                    }`}
                  onClick={() => handleThemeChange(icon?.theme)}
                />
              </div>
            </Tooltip>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ThemeSwitcher;
